<!-- Test-only page: text here is deliberately left untranslated (out of scope per #4317). -->
<cs-header>
  <cs-header-title>Testing</cs-header-title>
</cs-header>

<cs-content>
  <cs-card-list>
    <cs-card>
      <cs-item-list>
        <cs-item>
          <cs-label>Test Mode</cs-label>
          <cs-toggle [(checked)]="settings.testMode"></cs-toggle>
        </cs-item>
        <cs-item-list-header>Debugging tools</cs-item-list-header>
        <cs-item>
          <cs-button item-right small secondary (click)="handleSetFakeNow($event)" icon="calendar" [label]="'Set fake &quot;Now&quot;' | untranslated"></cs-button>
        </cs-item>
        <cs-item>
          <cs-button item-right small secondary (click)="handleUnsetFakeNow()" icon="calendar" [label]="'Unset fake &quot;Now&quot;' | untranslated"></cs-button>
        </cs-item>
        <cs-item>
          <cs-button item-right small secondary (click)="handleTestNotification()" icon="notifications" [label]="'Test Notification' | untranslated"></cs-button>
        </cs-item>
        <cs-item>
          <cs-button item-right small secondary (click)="handleUncacheAllFoods()" icon="trash" [label]="'Uncache All Foods' | untranslated"></cs-button>
        </cs-item>
        <cs-item>
          <cs-button item-right small secondary (click)="navCtrl.pushAsync(IDbSnapshotsPage)" icon="download"
            [label]="'Database Snapshots' | untranslated"></cs-button>
        </cs-item>
        <cs-item>
          <cs-button item-right small secondary (click)="navCtrl.pushAsync(IDbRestoreJsonPage)" icon="download"
            [label]="'Restore DB from JSON' | untranslated"></cs-button>
        </cs-item>
        <cs-item>
          <cs-button item-right small secondary (click)="handleBecomeDemoCoach()" icon="people"
            [label]="'Become a demo coach' | untranslated"></cs-button>
        </cs-item>
        <cs-item>
          <cs-button item-right small secondary (click)="handleRemoveDemoCoach()" icon="trash"
            [label]="'Remove demo coach data' | untranslated"></cs-button>
        </cs-item>
        <cs-item-list-header>Error testing</cs-item-list-header>
        <cs-item>
          <cs-button item-right small secondary (click)="handleFakeCrash()" icon="bug" [label]="'Fake a Crash (!)' | untranslated"></cs-button>
        </cs-item>
        <cs-item>
          <cs-button item-right small secondary (click)="handleFakeError()" icon="bug" [label]="'Fake an Error (!)' | untranslated"></cs-button>
        </cs-item>
        <cs-item>
          <cs-button item-right small secondary (click)="handleFakeException()" icon="bug" [label]="'Fake an Exception (!)' | untranslated"></cs-button>
        </cs-item>
        <cs-item>
          <cs-button item-right small secondary (click)="handleFakeSilentProblem()" icon="bug" [label]="'Fake a Silent Problem (!)' | untranslated"></cs-button>
        </cs-item>
        <cs-item>
          <cs-button item-right small secondary (click)="handleFakeFatalError()" icon="bug" [label]="'Fake a Fatal Error (!)' | untranslated"></cs-button>
        </cs-item>
        <cs-item>
          <cs-button item-right small secondary (click)="handleFakeDatabaseError()" icon="bug" [label]="'Fake Database Error (!)' | untranslated"></cs-button>
        </cs-item>
        <cs-item-list-header><!--footer--></cs-item-list-header>

        <cs-item-list-header>Server testing</cs-item-list-header>
        <cs-item>
          <cs-button item-right small secondary (click)="navCtrl.pushAsync(ITestWorkoutSolverPage)" icon="barbell"
            [label]="'Test Workout Solver' | untranslated"></cs-button>
        </cs-item>

        <cs-item-list-header>Page testing</cs-item-list-header>
        <cs-item>
          <cs-button item-right small secondary (click)="navCtrl.pushAsync(IIntroCarouselPage)" icon="bookmark"
            [label]="'Test Intro Carousel' | untranslated"></cs-button>
        </cs-item>
        <cs-item>
          <cs-button item-right small secondary (click)="navCtrl.pushAsync(ITestNavigationRootPage)" icon="link"
            [label]="'Test URL Navigation' | untranslated"></cs-button>
        </cs-item>
        <cs-item>
          <cs-button item-right small secondary (click)="navCtrl.pushAsync(ITestUiComponentsPage)" icon="beaker"
            [label]="'Test UI Components' | untranslated"></cs-button>
        </cs-item>
      </cs-item-list>
    </cs-card>
  </cs-card-list>

</cs-content>
